import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=0d517048"
import script from "./Mask.vue?vue&type=script&lang=ts"
export * from "./Mask.vue?vue&type=script&lang=ts"
import style0 from "./Mask.vue?vue&type=style&index=0&id=0d517048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports